/**
 * Footer component translations
 * Provides internationalization support for the Footer component
 */

interface FooterLocale {
  copyright: string;
  privacyPolicy: string;
  termsOfService: string;
  aboutUs: string;
  contact: string;
  help: string;
  accessibility: string;
  // ARIA labels
  footerNavigation: string;
  externalLink: string;
  footerLinks: string;
}

export const footerTranslations: Record<'es' | 'en', FooterLocale> = {
  es: {
    copyright: '© {year} HelpGrandpaPhish',
    privacyPolicy: 'Política de Privacidad',
    termsOfService: 'Términos de Servicio',
    aboutUs: 'Acerca de Nosotros',
    contact: 'Contacto',
    help: 'Ayuda',
    accessibility: 'Accesibilidad',
    // ARIA labels
    footerNavigation: 'Navegación del pie de página',
    externalLink: 'Enlace externo',
    footerLinks: 'Enlaces del pie de página',
  },
  en: {
    copyright: '© {year} HelpGrandpaPhish',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    aboutUs: 'About Us',
    contact: 'Contact',
    help: 'Help',
    accessibility: 'Accessibility',
    // ARIA labels
    footerNavigation: 'Footer navigation',
    externalLink: 'External link',
    footerLinks: 'Footer links',
  },
};